export default {"src":"/_next/static/media/osm-parkraum-logo-2025.93e277fb.svg","height":285,"width":300,"blurWidth":0,"blurHeight":0};